import { createContext, useContext } from 'react'
import type { UseFormRegister, FieldErrors } from 'react-hook-form'

/** After-submit behavior — published by the FormSubmitButton wrapper. */
export interface FormSuccessBehavior {
  successMessage: string
  successRedirectUrl: string
}

interface FormContextValue {
  register: UseFormRegister<Record<string, unknown>>
  errors: FieldErrors<Record<string, unknown>>
  isSubmitting: boolean
  /**
   * The submit button owns the after-submit props (success message /
   * redirect) and writes them here on render; the form owner (container)
   * reads them when a submission succeeds.
   */
  successRef?: { current: FormSuccessBehavior }
}

export const FormContext = createContext<FormContextValue | null>(null)

export function useFormContext() {
  return useContext(FormContext)
}
